import React, { useEffect, useState, useRef } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { Paper, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { WHITE, PRIMARY_LIGHT_BLUE } from "../../colors";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import HeightBox from "../../components/HeightBox";
import { AddifatNotMarriedPrintOut } from "../../components/Printouts/AffidatNotMarriedPrintOut";
import { AffidavitHaveChildrenPrintOut } from "../../components/Printouts/AffidatavitHaveChildrenPrintOut";
import { useHistory } from "react-router-dom";
import CustomerService from "../../services/customerService";
import FormEditService from "../../services/formEditService";
import { AFFIDAVIT_MARRIED_HAVE_CHILDREN } from "../../constants/formTypes";
import { APPROVED, IN_DRAFT, NEW_FORM } from "../../constants/formStates";
import FormStateLabel from "./FormStateLabel";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { getAge } from "../../util/calculations.utils";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "#F5F6F8",
  borderRadius: 10,
  paddingTop: 20,
  paddingLeft: 20,
  paddingBottom: 20,
  opacity: 0.9,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));
const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 18,
}));
const CustomIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 50,
  width: 50,
}));
const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 750,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));
const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 42,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));

const initialValues = {
  fullName: "",
  birthday: "",
  nationalId: "",
  lieceneId: "",
  passport: "",
  passport_issued: "",
  spouse: "",
  district: "",
  village: "",
  region: "",
  secretarial: "",
  guardiansName: "",
  guardian_nic: "",
  customer: "",
  address: "",
  child1db: "",
  child1name: "",
  child2name: "",
  child2db: "",
  child3name: "",
  child3db: "",
  child4name: "",
  child4db: "",
  child5name: "",
  child5db: "",
  child6name: "",
  child6db: "",
  child7name: "",
  child7db: "",
};
export const AffidatMarriedHaveChildren = (props) => {
  const [formValues, setFormValues] = useState(initialValues);
  const [pageInfo, setPageInfo] = useState({
    isDraft: false,
    isCreated: false,
  });
  const componentRef = useRef();
  const [childrenCount, setChildrenCount] = useState([{ id: 1, child1db: "", child1name: "" }]);
  let history = useHistory();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const handleSubmit = async () => {
    const res = submitAndPrint();
  };
  const submitAndPrint = async () => {
    try {
      if (!pageInfo.isCreated || (pageInfo.isCreated && !pageInfo.isDraft)) {
        const res = await FormEditService.createFormEdit(formValues);
      } else {
        const res = await FormEditService.updateFormEdit(props.customer, formValues);
      }

      alert("Successfully submitted the Application for Review");
      handlePrint();
      history.push("/forms");
      return true;
    } catch (e) {
      alert(e);
    }
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  useEffect(async () => {
    setIsDataLoaded(true);
    let newPageInfo = {
      isDraft: false,
      isCreated: false,
    };
    const getCustomer = async () => {
      const res = await CustomerService.getCustomerById(props.customer);
      return res.data;
    };
    const getFormDetails = async () => {
      const res = await FormEditService.getFormEditByCustomerAnType(props.customer, {
        type: AFFIDAVIT_MARRIED_HAVE_CHILDREN,
      });
      return res.data;
    };

    let secretarialName;
    let spouseName;
    let districtName;
    let child1nameNow;
    let child1dbNow;
    let child2nameNow;
    let child2dbNow;
    let child3nameNow;
    let child3dbNow;
    let child4nameNow;
    let child4dbNow;
    let child5nameNow;
    let child5dbNow;
    let child6nameNow;
    let child6dbNow;
    let child7nameNow;
    let child7dbNow;
    let guardNIC;
    let testVillage;
    let testReligion;
    try {
      const {
        id,
        isDraft,
        secretarial,
        spouse,
        district,
        child1db,
        child1name,
        child2name,
        child2db,
        child3name,
        child3db,
        child4name,
        child4db,
        child5name,
        child5db,
        child6name,
        child6db,
        child7name,
        child7db,
        guardian_nic,
        village,
        religion_sinhala,
      } = await getFormDetails();

      if (child1name) {
        setChildrenCount([{ id: 1, child1db, child1name }]);
      }
      if (child2name) {
        setChildrenCount([...childrenCount, { id: 2, child2db, child2name }]);
      }
      if (child3name) {
        setChildrenCount([...childrenCount, { id: 3, child3db, child3name }]);
      }
      if (child4name) {
        setChildrenCount([...childrenCount, { id: 4, child4db, child4name }]);
      }
      if (child5name) {
        setChildrenCount([...childrenCount, { id: 5, child5db, child5name }]);
      }
      if (child6name) {
        setChildrenCount([...childrenCount, { id: 6, child6db, child6name }]);
      }
      if (child7name) {
        setChildrenCount([...childrenCount, { id: 7, child7db, child7name }]);
      }

      secretarialName = secretarial;
      spouseName = spouse;
      districtName = district;
      child1dbNow = child1db;
      child1nameNow = child1name;
      child2nameNow = child2name;
      child2dbNow = child2db;
      child3nameNow = child3name;
      child3dbNow = child3db;
      child4nameNow = child4name;
      child4dbNow = child4db;
      child5nameNow = child5name;
      child5dbNow = child5db;
      child6nameNow = child6name;
      child6dbNow = child6db;
      child7nameNow = child7name;
      child7dbNow = child7db;
      guardNIC = guardian_nic;
      testVillage = village;
      testReligion = religion_sinhala;

      newPageInfo = {
        isDraft,
        isCreated: true,
      };
    } catch (error) {}

    const {
      guardian_name_sinhala,
      address,
      dob,
      full_name_sinhala,
      district,
      secretarial,
      village,
      region_sinhala,
      nic,
      license,
      passport,
      passport_issued,
      guardian_nic,
    } = await getCustomer();

    setFormValues({
      ...formValues,
      fullName: full_name_sinhala,
      birthday: dob,
      lieceneId: license,
      guardian_nic,
      guardiansName: guardian_name_sinhala,
      nationalId: nic,
      type: AFFIDAVIT_MARRIED_HAVE_CHILDREN,
      customer: props.customer,
      passport,
      passport_issued,
      secretarial,
      spouse: spouseName,
      district,
      address,
      child1db: child1dbNow,
      child1name: child1nameNow,
      child2name: child2nameNow,
      child2db: child2dbNow,
      child3name: child3nameNow,
      child3db: child3dbNow,
      child4name: child4nameNow,
      child4db: child4dbNow,
      child5name: child5nameNow,
      child5db: child5dbNow,
      child6name: child6nameNow,
      child6db: child6dbNow,
      child7name: child7nameNow,
      child7db: child7dbNow,
      village,
      religion: region_sinhala,
    });
    setPageInfo({ ...newPageInfo });
    setIsDataLoaded(false);
  }, [props.customer]);
  if (typeof props.customer !== "number") {
    return (
      <Container>
        <h2>Please select a customer</h2>
      </Container>
    );
  }
  return (
    <Container>
      <FormStateLabel type={pageInfo.isDraft ? IN_DRAFT : pageInfo.isCreated ? APPROVED : NEW_FORM} />
      <HeightBox height={20} />
      <div style={{ display: "none" }}>
        <AffidavitHaveChildrenPrintOut ref={componentRef} formValues={formValues} />
      </div>
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "30vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && (
        <>
          <Stack direction="row" spacing={5}>
            <Stack direction="column" spacing={2}>
              <HeightBox height={4} />
              <CustomTypography>National Id</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>District</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Secretarial Division</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Village</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Religion</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Liecene Number</CustomTypography>
              <HeightBox height={20} />
              <CustomTypography>Name</CustomTypography>
              <HeightBox height={15} />
              <CustomTypography>Passport Number</CustomTypography>
              <HeightBox height={15} />
              <CustomTypography>Passport Issued Date</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Spouce Name</CustomTypography>
            </Stack>
            <Stack direction="column" spacing={2}>
              <CustomTextField
                value={formValues.nationalId}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.district}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    district: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.secretarial}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    secretarial: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.village}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    village: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.religion}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    religion: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.lieceneId}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
              <CustomTextField
                value={formValues.fullName}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
              <CustomTextField
                value={formValues.passport}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    passport: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
              <CustomTextField
                type="date"
                value={formValues.passport_issued}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    passport_issued: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
              <CustomTextField
                value={formValues.spouse}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    spouse: e.target.value,
                  })
                }
              />
            </Stack>
          </Stack>
          <HeightBox height={20} />
          <Stack direction="row" spacing={5}>
            <CustomTypography style={{ marginTop: 10 }}>Guardian Name</CustomTypography>
            <div style={{ width: 1 }} />
            <CustomTextField
              style={{ width: 250 }}
              value={formValues.guardiansName}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  guardiansName: e.target.value,
                })
              }
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
            />
            <div style={{ width: 2 }} />
            <CustomTypography style={{ marginTop: 10 }}>Guardian's NIC</CustomTypography>
            <CustomTextField
              style={{ width: 250 }}
              value={formValues.guardian_nic}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  guardian_nic: e.target.value,
                })
              }
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
            />
          </Stack>
          <HeightBox height={40} />
          <Stack direction="column" spacing={1}>
            <Stack direction="row" spacing={5}>
              <div style={{ width: 300 }}>
                <CustomTypography>Children Name</CustomTypography>
              </div>
              <div style={{ width: 300 }}>
                <CustomTypography>Birthday</CustomTypography>
              </div>
              <div style={{ width: 300 }}>
                <CustomTypography>Age</CustomTypography>
              </div>
            </Stack>
            {childrenCount?.map((item) => (
              <Stack direction="row" key={item?.id} spacing={5}>
                <CustomTextField
                  style={{ width: 300 }}
                  value={formValues[`child${item?.id}name`]}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      [`child${item?.id}name`]: e.target.value,
                    })
                  }
                />
                <CustomTextField
                  type="date"
                  style={{ width: 300 }}
                  value={formValues[`child${item?.id}db`]}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      [`child${item?.id}db`]: e.target.value,
                    })
                  }
                />
                <CustomTextField
                  style={{ width: 300 }}
                  type="number"
                  value={getAge(formValues[`child${item?.id}db`])}
                />
                {item.id === childrenCount.length && childrenCount.length < 7 && (
                  <CustomIconButton
                    onClick={() => {
                      const obj = {
                        id: childrenCount.length + 1,
                        [`child${childrenCount.length + 1}db`]: "",
                        [`child${childrenCount.length + 1}name`]: "",
                      };
                      setChildrenCount([...childrenCount, { ...obj }]);
                    }}
                  >
                    <AddIcon fontSize="15px" />
                  </CustomIconButton>
                )}
              </Stack>
            ))}
          </Stack>
          <HeightBox height={20} />
          <Stack direction="row-reverse">
            <div style={{ width: 150 }} />
            {!pageInfo.isDraft && pageInfo.isCreated && (
              <CustomButton type="button" onClick={handlePrint}>
                Print{" "}
              </CustomButton>
            )}
            <div style={{ width: 20 }} />
            {!pageInfo.isDraft && pageInfo.isCreated && <CustomButton onClick={handleSubmit}>Submit </CustomButton>}
            <div style={{ width: 20 }} />
            {!pageInfo.isDraft && !pageInfo.isCreated && (
              <CustomButton onClick={handleSubmit}>Submit & Print </CustomButton>
            )}
          </Stack>
        </>
      )}
    </Container>
  );
};
